import {useEffect, useCallback} from 'react';

export const useTinkoffAuth = ({clientId, redirectUri, buttonContainerId}) => {

    const initTinkoffAuth = useCallback(() => {
        const container = document.getElementById(buttonContainerId);
        if (!container) return;

        container.innerHTML = '';

        const authParams = {
            redirectUri: redirectUri,
            responseType: 'code',
            clientId: clientId,
            state: `redirect=${window.location.href}`
        }

        const uiParams = {
            container: container,
            size: 'xs',
            color: 'primary',
            target: '_self'
        }

        const tidSdk = new TidSDK(authParams);

        tidSdk.addButton(uiParams);


    }, [clientId, redirectUri, buttonContainerId]);

    useEffect(() => {
        initTinkoffAuth()
    }, [buttonContainerId]);

    return {initTinkoffAuth};
};